import type { NDateLocale } from './enUS'
import { ja } from 'date-fns/locale'

const dateJaJP: NDateLocale = {
  name: 'ja-JP',
  locale: ja
}

export default dateJaJP
